import React from "react";

const SectionCard = ({ title, children }) => {
  return (
    <div className="section-card">
      {title && <h4>{title}</h4>}
      {children}
    </div>
  );
};

export default SectionCard;
